import { useState, useMemo } from 'react'
import { debounce } from '../../../utils'

const useDebouncedSearch = (callback, debounceTimeMs = 750) => {
  const debouncedSearchOnChange = useMemo(
    () => debounce(callback, debounceTimeMs),
    [],
  )

  const [value, setValue] = useState('')

  const handleChange = value => {
    setValue(value)
    debouncedSearchOnChange(value)
  }
  const handleClear = () => {
    setValue('')
    callback('')
  }
  return { value, handleChange, handleClear }
}

export default useDebouncedSearch
